import React, { Component } from "react";
import { admission } from "../config/api";

import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBRow, MDBCol } from "mdbreact";
import MetaTags from "react-meta-tags";
import axios from "axios";

export default class Tuitionfee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typestudent: null,
      typestudent_name: null,
      tuitionfee: [],
    };
  }

  componentDidMount() {
    this.setState({ typestudent: this.props.match.params.param });
    if (this.props.match.params.param === "1") {
      this.setState({ typestudent_name: "ปริญญาตรี ภาคปกติ (จันทร์-ศุกร์)" });
    } else if (this.props.match.params.param === "2") {
      this.setState({ typestudent_name: "ปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์)" });
    } else if (this.props.match.params.param === "3") {
      this.setState({ typestudent_name: "ปริญญาโท" });
    } else if (this.props.match.params.param === "4") {
      this.setState({ typestudent_name: "ปริญญาเอก" });
    } else {
      this.setState({ typestudent_name: "ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู" });
    }
    
    axios.get(admission + "/student/Tuitionfee").then((res) => {
      if (res.data.length !== 0) {
        const data = res.data;
        console.log(res.data);
        const DataTable = [];
        const normallkpp = [];
        const normallmaesort = [];
        const nurse = [];
        const holidaykpp = [];
        const holidaymaesort = [];
        const type = [];
        data.forEach((i, index) => {
          const fidn = type.find((value) => value.id === i.type_name);
          if (fidn !== "undefined") {
            type.push({ name: i.type_std_name, id: i.type_name });
          }else{
            type.append({ name: i.type_std_name, id: i.type_name });
          }
          //   console.log(i.facid)
          //   if (fidn !== "undefined") {
          //     type.push({ id: i.type_name, name: i.type_std_name });
          //   }
          //   console.log(index)

        });
        console.log(type)
      }
    });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลค่าธรรมเนียมการศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta name="description" content="ข้อมูลค่าธรรมเนียมการศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
          <meta property="og:title" content="ข้อมูลค่าธรรมเนียมการศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          {/* <MDBRow>
                    <MDBCol>
                        <h4>ข้อมูลค่าธรรมเนียมการศึกษา</h4>
                    </MDBCol>
                </MDBRow>
                <h5 className="card-header bg-danger text-white mb-2">ภาคปกติ กำแพงเพชร</h5>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#fbc02d yellow darken-2" textWhite>
                                <tr>
                                    <th colSpan="8">คณะวิทยาศาสตร์และเทคโนโลยี</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>เคมี (ค.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>64900 - 86900</td>
                                </tr>
                                <tr>
                                    <td>ฟิสิกส์ (ค.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>63400 - 85400</td>
                                </tr>
                                <tr>
                                    <td>ชีววิทยา (ค.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>63400 - 85400</td>
                                </tr>
                                <tr>
                                    <td>วิทยาการคอมพิวเตอร์ (วท.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีสารสนเทศ (วท.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>สาธารณสุขศาสตร์ (วท.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>นวัตกรรมและธุรกิจอาหาร (วท.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เคมี (วท.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>คณิตศาสตร์ (หลักสูตรควบ ระดับปริญญาตรี 2 ปริญญา)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>90600 - 112600</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#1e88e5 blue darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะครุศาสตร์</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>การศึกษาปฐมวัย (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>วิทยาศาสตร์ทั่วไป (ค.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>64900 - 86900</td>
                                </tr>
                                <tr>
                                    <td>คณิตศาสตร์ (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>61300 - 71300</td>
                                </tr>
                                <tr>
                                    <td>ภาษาอังกฤษ (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>61300 - 71300</td>
                                </tr>
                                <tr>
                                    <td>สังคมศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>61300 - 71300</td>
                                </tr>
                                <tr>
                                    <td>พลศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>61300 - 71300</td>
                                </tr>
                                <tr>
                                    <td>ภาษาจีน (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>คอมพิวเตอร์ (ค.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>ภาษาไทย (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>การประถมศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#fb8c00 orange darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะมนุษยศาสตร์และสังคมศาสตร์</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>ดนตรีศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>บรรณารักษศาสตร์และสารสนเทศศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>ศิลปศึกษา (ค.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>60000 - 82000</td>
                                </tr>
                                <tr>
                                    <td>ภาษาไทย (ศศ.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>ภาษาอังกฤษ (ศศ.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การพัฒนาสังคม (ศศ.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>ภาษาจีน (ศศ.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>นิติศาสตร์ (น.บ. 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>รัฐประศาสนศาสตร์ (รป.บ. 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>63500 - 73500</td>
                                </tr>
                                <tr>
                                    <td>ภูมิสารสนเทศ (วท.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#d81b60 pink darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะวิทยาการจัดการ</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>การตลาด (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การเงิน (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (บธ.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9000 - 10000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9800 - 10800</td>
                                    <td>57200 - 67200</td>
                                </tr>
                                <tr>
                                    <td>การจัดการธุรกิจ (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การเป็นผู้ประกอบการ (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (บช.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>นิเทศศาสตร์ (นศ.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>อุตสาหกรรมการท่องเที่ยว (ศศ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#5e35b1 deep-purple darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะเทคโนโลยีอุตสาหกรรม</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>เทคโนโลยีวิศวกรรมไฟฟ้า (ทล.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีวิศวกรรมไฟฟ้า (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9000 - 10000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9800 - 10800</td>
                                    <td>60200 - 70200</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีพลังงาน (ทล.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีวิศวกรรมโยธา (ทล.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีวิศวกรรมโยธา (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9000 - 10000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9800 - 10800</td>
                                    <td>60200 - 70200</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีคอมพิวเตอร์ (วท.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีคอมพิวเตอร์ (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9000 - 10000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9800 - 10800</td>
                                    <td>60200 - 70200</td>
                                </tr>
                                <tr>
                                    <td>ออกแบบผลิตภัณฑ์และกราฟิก (ศป.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>อุตสาหกรรมศิลป์ (ค.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>การจัดการโลจิสติกส์ (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีไฟฟ้าสื่อสารและสารสนเทศ (ทล.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีการผลิตและระบบอัตโนมัติ (ทล.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#43a047 green darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะพยาบาลศาสตร์</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>พยาบาลศาสตร์ (พย.บ 4 ปี)</td>
                                    <td>45000 - 46000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>45800 - 46800</td>
                                    <td>400000 - 410000</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
                <h5 className="card-header bg-danger text-white mb-2">ภาคปกติ แม่สอด</h5>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#d81b60 pink darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะวิทยาการจัดการ</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>การจัดการธุรกิจระหว่างประเทศ (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การจัดการธุรกิจระหว่างประเทศ (สำหรับผู้ที่สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>57200 - 67200</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (บธ.บ 4 ปี)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>65700 - 87700</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9000 - 10000</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9800 - 10800</td>
                                    <td>60200 - 70200</td>
                                </tr>
                                <tr>
                                    <td>การเป็นผู้ประกอบการ (บธ.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (บช.บ 4 ปี)</td>
                                    <td>8000 - 10200</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>8800 - 11000</td>
                                    <td>62000 - 72000</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>8500 - 10700</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9300 - 11500</td>
                                    <td>57200 - 67200</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#fb8c00 orange darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะมนุษยศาสตร์และสังคมศาสตร์</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>รัฐประศาสนศาสตร์ (รป.บ. 4 ปี)</td>
                                            <td>8000 - 10200</td>
                                            <td>200</td>
                                            <td>200</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>8800 - 11000</td>
                                            <td>63500 - 73500</td>
                                        </tr>
                                        <tr>
                                            <td>เทคโนโลยีโลจิสติกส์ (วท.บ 4 ปี)</td>
                                            <td>8500 - 10700</td>
                                            <td>200</td>
                                            <td>200</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>9300 - 11500</td>
                                            <td>65700 - 7500</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#5e35b1 deep-purple darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะเทคโนโลยีอุตสาหกรรม</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>การจัดการโลจิสติกส์ (บธ.บ 4 ปี)</td>
                                            <td>8000 - 10200</td>
                                            <td>200</td>
                                            <td>200</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>8800 - 11000</td>
                                            <td>63500 - 73500</td>
                                        </tr>
                                        <tr>
                                            <td>เทคโนโลยีคอมพิวเตอร์ (วท.บ 4 ปี)</td>
                                            <td>8500 - 10700</td>
                                            <td>200</td>
                                            <td>200</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>9300 - 11500</td>
                                            <td>65700 - 7500</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
                <h5 className="card-header bg-danger text-white mb-2">ภาคกศ.บป. กำแพงเพชร</h5>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#d81b60 pink darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะวิทยาการจัดการ</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>การเงิน (บธ.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การจัดการธุรกิจ (บธ.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (บช.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9500 - 10500</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10400 - 11400</td>
                                    <td>74000 - 84000</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#fb8c00 orange darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะมนุษยศาสตร์และสังคมศาสตร์</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>นิติศาสตร์ (น.บ. 4 ปี)</td>
                                            <td>9300 - 11500</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>10200 - 11200</td>
                                            <td>102300 - 112300</td>
                                        </tr>
                                        <tr>
                                            <td>รัฐประศาสนศาสตร์ (รป.บ. 4 ปี)</td>
                                            <td>8800 - 11000</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>9700 - 10700</td>
                                            <td>88000 - 98000</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#5e35b1 deep-purple darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะเทคโนโลยีอุตสาหกรรม</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>เทคโนโลยีคอมพิวเตอร์ (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                            <td>10000 - 11000</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>10900 - 11900</td>
                                            <td>100700 - 110700</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
                <h5 className="card-header bg-danger text-white mb-2">ภาคกศ.บป. แม่สอด</h5>
                <MDBRow>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBTable responsive btn bordered scrollX striped>
                            <MDBTableHead color="#d81b60 pink darken-1" textWhite>
                                <tr>
                                    <th colSpan="8">คณะวิทยาการจัดการ</th>
                                </tr>
                                <tr>
                                    <th>สาขาวิชา/วิชาเอก</th>
                                    <th>ค่าเทอม</th>
                                    <th>คู่มือนักศึกษา</th>
                                    <th>ขึ้น น.ศ.ใหม่</th>
                                    <th>ออกบัตร</th>
                                    <th>ประกันของเสียหาย</th>
                                    <th>รวม</th>
                                    <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <td>การจัดการธุรกิจ (บธ.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การจัดการธุรกิจ (สำหรับผู้ที่สำเร็จการศึกษาระดับ ปวส. หรือ เทียบเท่า)</td>
                                    <td>9500 - 10500</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10400 - 11400</td>
                                    <td>74000 - 84000</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (บช.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การบัญชี (สำหรับผู้สำเร็จการศึกษาระดับ ปวส. หรือเทียบเท่า)</td>
                                    <td>9500 - 10500</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10400 - 11400</td>
                                    <td>74000 - 84000</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (บธ.บ 4 ปี)</td>
                                    <td>9300 - 11500</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10200 - 11200</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>เทคโนโลยีธุรกิจดิจิทัล (สำหรับผู้ที่สำเร็จการศึกษาระดับ ปวส. หรือ เทียบเท่า)</td>
                                    <td>10000 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10900 - 11900</td>
                                    <td>74000 - 84000</td>
                                </tr>
                                <tr>
                                    <td>การเป็นผู้ประกอบการ (บธ.บ 4 ปี)</td>
                                    <td>8800 - 11000</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>9700 - 10700</td>
                                    <td>95500 - 105500</td>
                                </tr>
                                <tr>
                                    <td>การเป็นผู้ประกอบการ (สำหรับผู้ที่สำเร็จการศึกษาระดับ ปวส. หรือ เทียบเท่า)</td>
                                    <td>9500 - 10500</td>
                                    <td>200</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td>300</td>
                                    <td>10400 - 11400</td>
                                    <td>74000 - 84000</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                    <MDBCol lg="6" md="12" sm="12">
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#fb8c00 orange darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะมนุษยศาสตร์และสังคมศาสตร์</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>รัฐประศาสนศาสตร์ (รป.บ 4 ปี)</td>
                                            <td>8800 - 11000</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>9700 - 10700</td>
                                            <td>88000 - 98000</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <MDBTable responsive btn bordered scrollX striped>
                                    <MDBTableHead color="#5e35b1 deep-purple darken-1" textWhite>
                                        <tr>
                                            <th colSpan="8">คณะเทคโนโลยีอุตสาหกรรม</th>
                                        </tr>
                                        <tr>
                                            <th>สาขาวิชา/วิชาเอก</th>
                                            <th>ค่าเทอม</th>
                                            <th>คู่มือนักศึกษา</th>
                                            <th>ขึ้น น.ศ.ใหม่</th>
                                            <th>ออกบัตร</th>
                                            <th>ประกันของเสียหาย</th>
                                            <th>รวม</th>
                                            <th>การประมาณค่าใช้จ่ายตลอดหลักสูตร</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td>การจัดการโลจิสติกส์ (บธ.บ 4 ปี)</td>
                                            <td>8800 - 11000</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>9700 - 10700</td>
                                            <td>88000 - 98000</td>
                                        </tr>
                                        <tr>
                                            <td>เทคโนโลยีคอมพิวเตอร์ (วท.บ 4 ปี)</td>
                                            <td>9300 - 11500</td>
                                            <td>200</td>
                                            <td>300</td>
                                            <td>100</td>
                                            <td>300</td>
                                            <td>10200 - 11200</td>
                                            <td>100700 - 110700</td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow> */}
        </MDBContainer>
      </>
    );
  }
}
